import { useState, useEffect, useMemo } from 'react';
import { throttleFunction } from '../../utils/throttle';

const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  const listener = useMemo(
    () =>
      throttleFunction(() => {
        const media = window.matchMedia(query);
        setMatches(media.matches);
      }),
    [query],
  );

  useEffect(() => {
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [listener]);

  return matches;
};

export default useMediaQuery;

export const useIsDesktop = () => useMediaQuery('(min-width: 960px)');
